const Adress = {
    backendUrl: 'https://jekforms-git-productionbackend-jek.vercel.app',
  };
  
  export default Adress;